export default __webpack_public_path__ + "static/granular-conversion-time-distribution-light-mode-33e17ff7f507515a7a09d662bb3f2e96.png";